<template>
    <div class="swiper-container">
        <ul class="swiper-wrapper">
            <slot></slot>
        </ul>
        <slot name="pagination"></slot>
    </div>
</template>

<script>
import Swiper, { Autoplay, Pagination } from 'swiper';
import 'swiper/swiper-bundle.css';

Swiper.use(Autoplay);
Swiper.use(Pagination);

import { mergeDeepRight } from 'ramda';
export default {
    name: 'swiper-container',
    props: {
        opt: {
            type: Object,
            default: () => ({}),
        },
        //几种预设模板
        type: {
            type: Number,
        },
    },
    data() {
        return {
            inst: null,
        };
    },
    mounted() {
        const that = this;
        let opt = {
            on: {
                //swiper 会改this指向自己
                slideChangeTransitionEnd() {
                    that.$emit('slide-change-end', this.realIndex);
                },
                slideChange() {
                    that.$emit('slide-change', this.realIndex);
                },
            },
            ...this.opt,
        };
        if (this.type !== undefined) {
            if (this.type === 0) {
                opt = mergeDeepRight(
                    opt,
                    mergeDeepRight(
                        {
                            autoplay: {
                                delay: 2 * 1000,
                            },
                            slidesPerView: 'auto',
                            centeredSlides: true,
                            spaceBetween: 10,
                            loop: true,
                        },
                        this.opt
                    )
                );
            }
        }
        this.inst = new Swiper(this.$el, opt);
    },
    beforeDestroy() {
        this.inst.destroy();
    },
    methods: {
        //上一页
        slidePrev(...args) {
            this.inst.slidePrev(...args);
        },
        //下一页
        slideNext(...args) {
            this.inst.slideNext(...args);
        },
        //跳到
        slideTo(...args) {
            this.inst.slideTo(...args);
        },
    },
};
</script>

<style lang="less">
.swiper-pagination-bullet {
    opacity: 1;
}
</style>
